import {
  FETCH_CART_MOMENTS,
  FETCH_CART_SELECTIONS,
  SELECT_CART_MOMENTS,
  UNSELECT_CART_MOMENTS,
  REMOVE_CART_MOMENT,
  SET_PURCHASE_REQUEST,
  FETCH_PURCHASES,
  FETCH_PRINTS,
  SELECT_PRINTS,
  UNSELECT_PRINTS,
  SET_PURCHASED,
  FETCH_PURCHASED_MOMENT_IDS,
  FETCH_PURCHASE_CALCULATIONS,
  ADD_PURCHASE,
  CLEAR_PURCHASE_REQUEST,
  SET_AS_MOBILE_CART,
  SHOW_MOBILE_CART_PREMIUM_GALLERY,
  SHOW_CHECKOUT_FORM,
  SET_PURCHASING_LOADING,
  APPLY_DISCOUNT_COUPON,
  SET_PRINT_SIZES,
  GET_SELECTED_PRINT_SIZES,
  CLEAR_SELECTED_PRINT_SIZES,
  RE_KNOCKOUT_MOMENT,
  PREMIUM_GALLERY_LOADED
} from 'shared/actions/types';

import CartService from 'shared/services/CartService';
import PurchaseService from 'shared/services/PurchaseService';

export const showMobileCartPremiumGallery = visible => dispatch => {
  dispatch({
    type: SHOW_MOBILE_CART_PREMIUM_GALLERY,
    payload: visible
  });
}

export const setPremiumGalleryLoaded = loaded => dispatch => {
  dispatch({
    type: PREMIUM_GALLERY_LOADED,
    payload: loaded
  });
}

export const setMobileCartView = isMobileCart => dispatch => {
  dispatch({
    type: SET_AS_MOBILE_CART,
    payload: isMobileCart
  });
}

export const showCheckOutForm = visible => dispatch => {
  dispatch({
    type: SHOW_CHECKOUT_FORM,
    payload: visible
  });
}

export const getMoments = (token, storyId, opts = {}) => dispatch => {
  return CartService.getMoments(token, storyId)
    .then(moments => {
      // filter out purchased moments
      if (!opts.includePurchased) {
        moments = moments.filter(m => !m.purchased);
      }

      dispatch({
        type: FETCH_CART_MOMENTS,
        payload: moments
      });

      return Promise.resolve(moments);
    });
}

export const getSelections = storyId => dispatch => {
  return CartService.getSelections(storyId)
    .then(selections => {
      dispatch({
        type: FETCH_CART_SELECTIONS,
        payload: selections
      });

      return Promise.resolve(selections);
    });
}

export const selectMoments = (storyId, momentIds) => dispatch => {
  dispatch({
    type: SELECT_CART_MOMENTS,
    payload: momentIds
  });

  return CartService.selectMoments(storyId, momentIds)
    .then(() => Promise.resolve(momentIds))
    .catch(err => {
      console.error(err);

      dispatch({
        type: UNSELECT_CART_MOMENTS,
        payload: momentIds
      });
    });
}

export const unselectMoments = (storyId, momentIds) => dispatch => {
  dispatch({
    type: UNSELECT_CART_MOMENTS,
    payload: momentIds
  });

  return CartService.unselectMoments(storyId, momentIds)
    .then(() => Promise.resolve(momentIds))
    .catch(err => {
      console.error(err);

      dispatch({
        type: SELECT_CART_MOMENTS,
        payload: momentIds
      });
    });
}

export const removeMoment = (storyId, momentId) => dispatch => {
  return CartService.removeMoment(storyId, momentId)
    .then(() => {
      dispatch({
        type: REMOVE_CART_MOMENT,
        payload: momentId
      });

      return Promise.resolve();
    });
}

export const selectPrints = (storyId, momentIds, v2) => async dispatch => {
  dispatch({
    type: SELECT_PRINTS,
    payload: momentIds
  });

  return await CartService.selectPrints(storyId, momentIds, v2)
    .then(() => Promise.resolve(momentIds))
    .catch(err => {
      console.error(err);

      dispatch({
        type: UNSELECT_PRINTS,
        payload: momentIds
      });
    });
}

export const unselectPrints = (storyId, momentIds, v2, clearAll) => dispatch => {
  dispatch({
    type: UNSELECT_PRINTS,
    payload: { momentIds: momentIds, clearAll: clearAll }
  });

  return CartService.unselectPrints(storyId, momentIds, v2, clearAll)
    .then(() => Promise.resolve(momentIds))
    .catch(err => {
      console.error(err);

      dispatch({
        type: SELECT_PRINTS,
        payload: momentIds
      });
    });
}

export const selectPurchasedPrint = (token, purchaseId, momentId) => dispatch => {
  let params = {
    purchase_id: purchaseId,
    moment_id: momentId
  }

  return CartService.createPrint(token, params)
    .then(() => {
      dispatch({
        type: SELECT_PRINTS,
        payload: [momentId]
      });

      return Promise.resolve();
    });
}

export const unselectPurchasedPrint = (token, print) => dispatch => {
  return CartService.destroyPrint(token, print.id)
    .then(() => {
      dispatch({
        type: UNSELECT_PRINTS,
        payload: [print.moment_id]
      });

      return Promise.resolve();
    });
}

export const createPurchaseRequest = (token, params) => dispatch => {
  return CartService.createPurchaseRequest(token, params)
    .then(purchaseRequest => {
      dispatch({
        type: SET_PURCHASE_REQUEST,
        payload: purchaseRequest
      });

      return Promise.resolve();
    });
}

export const clearPurchaseRequest = () => dispatch => {
  dispatch({
    type: CLEAR_PURCHASE_REQUEST
  });

  return Promise.resolve();
}

export const getPurchases = storyId => dispatch => {
  return CartService.getPurchases(storyId)
    .then(purchases => {
      dispatch({
        type: FETCH_PURCHASES,
        payload: purchases
      });

      return Promise.resolve();
    });
}

export const getPrints = storyId => dispatch => {
  return CartService.getPrints(storyId)
    .then(prints => {
      if (prints) {
        dispatch({
          type: FETCH_PRINTS,
          payload: prints
        });
      }

      return Promise.resolve();
    });
}

export const setPurchased = (momentIds = []) => dispatch => {
  dispatch({
    type: SET_PURCHASED,
    payload: momentIds
  });

  return Promise.resolve();
}

export const getPurchasedMomentIds = storyId => dispatch => {
  return CartService.getPurchasedMomentIds(storyId)
    .then(momentIds => {
      if (momentIds) {
        dispatch({
          type: FETCH_PURCHASED_MOMENT_IDS,
          payload: momentIds
        });

        return Promise.resolve();
      }
    });
}

export const getPurchaseCalculations = (storyId, maxQuantity, couponCode = "") => dispatch => {
  return CartService.getPurchaseCalculations(storyId, maxQuantity, couponCode)
    .then(calculations => {
      dispatch({
        type: FETCH_PURCHASE_CALCULATIONS,
        payload: calculations
      });

      return Promise.resolve();
    });
}

export const purchase = params => dispatch => {
  return PurchaseService.purchase(params)
    .then(purchase => {
      dispatch({
        type: ADD_PURCHASE,
        payload: {
          purchase,
          momentIds: params.moment_ids
        }
      });

      return Promise.resolve(purchase);
    });
}

export const addPurchase = (purchase, momentIds) => dispatch => {
  dispatch({
    type: ADD_PURCHASE,
    payload: {
      purchase,
      momentIds: momentIds
    }
  });

  return Promise.resolve();
}

export const setPurchaseLoading = loading => dispatch => {
  dispatch({
    type: SET_PURCHASING_LOADING,
    payload: loading
  });
}

export const applyDiscountCoupon = (productId, couponCode, purchaseTotal) => async dispatch => {
  return await CartService.applyDiscountCode(productId, couponCode, purchaseTotal).then((result) => {
    dispatch({
      type: APPLY_DISCOUNT_COUPON,
      payload: result.discount_code != undefined
    });
    return Promise.resolve(result.message);
  })
}

export const getSelectedPrintSizes = (storyId) => dispatch => {
  return CartService.getSelectedPrintSizes(storyId).then((result) => {
    var selections = result || [];
    dispatch({
      type: GET_SELECTED_PRINT_SIZES,
      payload: selections
    });
    return Promise.resolve(selections);
  })
}

export const setPrintSizes = sizes => dispatch => {
  dispatch({
    type: SET_PRINT_SIZES,
    payload: sizes
  })
}

export const selectPrintSizes = (storyId, params) => () => {
  return CartService.selectPrintSizes(storyId, params);
}

export const clearSelectedPrintSizes = (storyId, momentId) => dispatch => {
  return CartService.clearSelectedPrintSizes(storyId, momentId).then(() => {
    dispatch({
      type: CLEAR_SELECTED_PRINT_SIZES,
      payload: { story_id: storyId, moment_id: momentId }
    })
  })
}

export const reKnockOutMoment = (momentId, kioskToken) => async dispatch => {
  return await CartService.reKnockOutMoment(momentId, kioskToken).then((result) => {
    dispatch({
      type: RE_KNOCKOUT_MOMENT,
      payload: result
    })
    return Promise.resolve(result);
  })
}
